<template>
  <div class="aside" style="font-size: 14px">
    <ul>
      <li @click="asideHelp()">
        <a></a>
      </li>
      <li id="aside_service" @click="openFrame">
        <a></a>
      </li>
      <li class="pop_box">
        <!--  @mousemove="telMove" @mouseleave="telLeave"  -->
        <a></a>
        <div class="pop" ref="pop">
          <em></em>
          <p>
            <label>Tel:</label>
            <a href="tel:4006265026">400-626-5026</a>
          </p>
          <p>
            <label>QQ:</label>
            <a
              href="http://wpa.qq.com/msgrd?v=3&uin=1732975757&site=qq&menu=yes"
              target="_blank"
              title="1732975757"
              >1732975757</a
            >
          </p>
          <p>
            <label>E-mail:</label>
            <a
              href="mailto:fifedu@iflytek.com"
              target="_blank"
              title="fifedu@iflytek.com"
              >fifedu@iflytek.com</a
            >
          </p>
          <p>
            <label>服务时间</label>
            每天 8:00~22:30
          </p>
        </div>
      </li>
    </ul>
    <div v-show="showFrame" class="service-iframe">
      <div
        id="kf5-support-block"
        class="kf5-supportBox"
        style="display: block; bottom: 10px"
      >
        <span
          id="kf5-close-btn"
          class="kf5-support-chat_close kf5-waves"
          @click="offIframe()"
        ></span>
        <iframe
          id="kf5-widget-iframe"
          class="kf5-supportBox_iframe"
          frameborder="0"
          scrolling="no"
        ></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      showFrame: false,
      isLogin: false,
    };
  },
  created() {
    let isIndex = sessionStorage.getItem("isIndex");
    if (isIndex == "1") {
      this.isLogin = true;
    }
    this.createdIframe();
  },
  computed: {},
  mounted() {
    this.asideFunc();
    this.createdIframe();
  },
  methods: {
    // telMove() {
    //   this.$refs.pop.style = "transform: scale(1);";
    // },
    // telLeave() {
    //   this.$refs.pop.style = "transform: scale(0);";
    // },
    asideFunc: function () {
      //右侧二维码
      $(".pop_box").hover(function(){
        $(this).children(".pop").css("transform", "scale(1)")
      },function(){
        $(this).children(".pop").css("transform", "scale(0)")
      });
    },
    asideHelp() {
      var url;
      if (this.isLogin) {
        url = this.initData(this.getBasePath() + "/member/help", "post").data
          .url;
      } else {
        url = "https://fif.kf5.com/hc/";
      }
      window.open(url);
    },
    createdIframe(){
      $('.kf5-supportBox_iframe').attr('src',"https://fif.kf5.com/kchat");
      // var iframeDom = '<script src="/assets-cdn.kf5.com/supportbox/main.js?' + (new Date).getDay() + '" id="kf5-widget-iframe" kf5-domain="fif.kf5.com" charset="utf-8"><\/script>'
      // // var iframeDom = '<iframe id="kf5-widget-iframe" class="kf5-supportBox_iframe" frameborder="0" scrolling="no" src="https://fif.kf5.com/kchat" />';
      // $('.kf5-supportBox').append(iframeDom);

      // var script = document.createElement('script');
      // script.id = 'kf5-provide-supportBox';
      // script.src = '//assets-cdn.kf5.com/supportbox/main.js?' + (new Date).getDay(); ////assets-cdn.kf5.com/supportbox/main.js?2
      // document.body.append(script);
    },
    openFrame() {
      $(".service-iframe").css({ animation: "leave 0.75s" });
      $(".kf5-supportBox").css({ animation: "leave 0.75s" });
      $("#kf5-widget-iframe").css({ animation: "leave 0.75s" });
      $(".kf5-support-chat_close").css({ animation: "leave 0.75s" });
      this.showFrame = true;
    },
    offIframe() {
      $(".service-iframe").css({ animation: "come 0.75s" });
      // $(".kf5-supportBox").css({ animation: "come 0.75s" });
      $("#kf5-widget-iframe").css({ animation: "come 0.75s" });
      // $(".kf5-support-chat_close").css({ animation: "come 0.75s" });
      setTimeout(() => {
        this.showFrame = false;
      }, 750);
    },
    getHostPath() {
      var curWwwPath = window.document.location.href;
      var pathName = window.document.location.pathname;
      var pos = curWwwPath.indexOf(pathName);
      var localhostPath = curWwwPath.substring(0, pos);
      // http://bfsu.meixuego.com
      return localhostPath;
    },
    //获取base路径
    getBasePath() {
      return this.getHostPath() + "/iplat/bp"; //线上接口
    },
    initData(url, datatype, dataval, opentype) {
      var mydata;
      $.ajax({
        url: url,
        type: datatype,
        async: false, //同步
        data: dataval ? dataval : "",
        dataType: "json",
        timeout: 60000,
        success: function (data) {
          if (data.status != "SUCCESS") {
            mydata = false;
            return;
          } else {
            mydata = data;
          }
        },
        error: function (e1, e2, e3) {
          this.$message("网络开小差了，请稍后再试！");
        },
      });
      return mydata;
    },
  },
};
</script>

<style scope lang="less">
/* iframe */
.service-iframe {
  height: 540px;
  width: 360px;
  position: fixed;
  right: 55px;
  bottom: 10px;
  background: #ddd;
  z-index: 1;
  transform-origin: center bottom;
  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  animation: leave 1s;
}
.kf5-supportBox {
  position: fixed;
  overflow: hidden;
  z-index: 2;
  border-radius: 2px;
  animation: leave 1s;
}
#kf5-widget-iframe {
  width: 360px;
  height: 540px;
  position: fixed;
  right: 55px;
  bottom: 10px;
  animation: leave 1s;
}
.kf5-chatSupport-right-bottom .kf5-supportBox {
  right: 55px;
  bottom: 10px;
}
.kf5-support-chat_close {
  background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgMTcgOSI+PHBhdGggZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMCAuNDVDMCAuMzM1LjA0Ni4yMi4xMzMuMTMyYy4xNzQtLjE3Ni40NTgtLjE3Ni42MzIgMEw4LjUgNy45MTJsNy43MzctNy43OGMuMTc0LS4xNzYuNDU4LS4xNzYuNjMyIDAgLjE3My4xNzUuMTczLjQ2IDAgLjYzNmwtOC4wNTUgOC4xYy0uMTc0LjE3Ni0uNDU4LjE3Ni0uNjMyIDBMLjEzLjc2OEMuMDQ0LjY4IDAgLjU2NSAwIC40NDhWLjQ1eiIvPjwvc3ZnPg==)
    no-repeat 50%;
  opacity: 0.6;
  width: 30px;
  height: 30px;
  position: fixed;
  bottom: 517px;
  right: 63px;
  overflow: visible;
  z-index: 199;
  animation: leave 1s;
}
@keyframes leave {
  0% {
    bottom: -500px;
  }
  100% {
    bottom: 10px;
  }
}
@keyframes come {
  0% {
    bottom: 10px;
  }
  100% {
    bottom: -600px;
  }
}
.kf5-support-chat * {
  margin: 0;
  padding: 0;
  box-sizing: content-box;
}
/* iframe */

// @import '../assets/css/style.css';
/* 侧边栏 */
.aside {
  width: 56px;
  height: 176px;
  position: fixed;
  top: 42%;
  right: 0;
  z-index: 100;
  ul {
    background: #262626;
    border-radius: 12px 0 0 12px;
  }
  ul li {
    width: 56px;
    height: 56px;
    border-radius: 0;
    position: relative;
    > a {
      display: block;
      width: 56px;
      height: 56px;
      font-size: 0;
      line-height: 0;
      padding-top: 0;
    }
  }
}
.aside ul > li:nth-child(1) > a {
  background: url("../assets/img/second_img/ico_helpCenter.svg") no-repeat
    center;
  border-radius: 12px 0 0 0;
}
.aside ul > li:nth-child(1) > a:hover {
  background: url("../assets/img/second_img/help_ic.png") no-repeat center;
  background-size: 105%;
}

.aside ul > li:nth-child(2) > a {
  background: url("../assets/img/second_img/ico_customerService.png") no-repeat
    center;
}
.aside ul > li:nth-child(2) > a:hover {
  background: url("../assets/img/second_img/ser_ic.png") no-repeat center;
  background-size: 105%;
}

.aside ul > li:nth-child(3) > a {
  background: url("../assets/img/second_img/ico_contectFiF.svg") no-repeat
    center;
  border-radius: 0 0 0 12px;
}
.aside ul > li:nth-child(3) > a:hover {
  background: url("../assets/img/second_img/us_ic.png") no-repeat center;
  background-size: 105%;
}
/* 划过气泡 */
.pop {
  transform: scale(0);
  background: #ffffff;
  border: 1px solid #e5e5e5;
  box-shadow: 0 16px 32px -10px rgba(5, 14, 26, 0.2);
  border-radius: 8px;
  margin-right: 70px;
  width: 196px;
  padding: 20px 40px 20px 24px;
  position: absolute;
  right: 10px;
  top: 0;
  transition: transform 0.25s ease;
  transform-origin: 110% 30%;
  em {
    margin-top: -45px;
    background-position: -2653px -1085px;
    display: inline-block;
    width: 25px;
    height: 25px;
    right: -25px;
    top: 28%;
    margin-top: -35px;
    position: absolute;
    background: url("../assets/img/index1.png") -2653px -1085px no-repeat;
  }
  p {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: normal;
    line-height: 20px;
    overflow: hidden;
    white-space: nowrap;
    padding-bottom: 12px;
    label {
      float: left;
      width: 60px;
      font-size: 14px;
      color: #3388ff;
      padding-right: 16px;
    }
    a {
      color: #4a4a4a;
      float: left;
    }
  }
  p:last-child {
    padding-bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/aside.vue